export enum EnumServiceType {
    Laboratory = 1,
    Radiology = 2,
    Clinics = 3,
    PhysicalTherapy = 4,
    Drugs = 5,
    MedicalSupplies = 6,
    Dialysis = 7,
    Heartdisease = 8,
    Nuclearmedicine = 9,
    radiationtherapy = 10,
    MedicalService = 11,
    Other = 12,
    Surgery = 13,
    Catheter = 14,
    Endoscopy = 15,
    Emergency = 16,
    Any = 17,
    ComprehensiveExamine = 18,
    BloodBank = 19,
    OperationServices = 20,
    TherapeuticFeedingObesity = 21,
    DermatologyCosmeticLaser = 22,
    TeethOrder = 24,
    BreastFeeding = 27

}



